import React from 'react'
import { Icon } from '../atoms/Icon'
import { Theme } from '@theme'
import { StyleSheet, TouchableOpacity } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { useLanguage } from '@context'
import { Text } from '../atoms'

// `label`: « Fermer » where nothing is cancelled (the note editor saves by
// itself); « Annuler » by default.
export const CloseButton = ({ onPress, label }: { onPress: () => void; label?: string }) => {
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyle(theme)

  return (
    <TouchableOpacity style={styles.cancelButton} onPress={onPress}>
      <Icon name="cross" size={20} color={theme.colors.primary} />
      <Text style={styles.cancelButtonText} type="body">
        {label ?? t('common.cancel')}
      </Text>
    </TouchableOpacity>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    cancelButton: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.sm,
    },
    cancelButtonText: {
      color: theme.colors.primary,
    },
  })
